import { cn } from "cy-fe/src/utils/cn";

export function BodyContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mx-auto mt-5 w-[90dvw] max-w-lg space-y-6 px-2 pb-4 md:w-[70dvw]",
        className,
      )}
    >
      {children}
    </div>
  );
}
